import { CrewEventModel } from "../crews/scheduler-stores";
import EventHelperCommon from "./common";

import C from "../Constants";

/**
 * 下船中様態イベントモデルを新規作成する
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {String} status_id
 * @param {String} crew_role_id
 * @returns {CrewEventModel}
 */
const newAshoreEvent = (startDate, endDate, status_id, crew_role_id) => {
  return new CrewEventModel({
    startDate: startDate,
    endDate: endDate,
    phantom_group_key: EventHelperCommon.genPhantomGroupKey(),
    enterprise_manning_status_id: status_id,
    enterprise_crew_role_id: crew_role_id,
    event_type: C.SCHEDULING_EVENT_TYPE.ASHORE,
    scheduling_status: C.SCHEDULING_STATUS.SCHEDULED,
  });
};

/**
 * 休暇希望イベントモデルを新規作成する
 * @param {Date} startDate
 * @param {Date} endDate
 * @returns
 */
const newDayOffRequestEvent = (startDate, endDate) => {
  return new CrewEventModel({
    startDate: startDate,
    endDate: endDate,
    phantom_group_key: EventHelperCommon.genPhantomGroupKey(),
    event_type: C.SCHEDULING_EVENT_TYPE.DAY_OFF_REQUEST,
    scheduling_status: C.SCHEDULING_STATUS.SCHEDULED,
    priority: C.DAY_OFF_REQUEST_PRIORITY.LOW,
  });
};

/**
 * 乗船期間イベントモデルを新規作成する
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {String} enterprise_manning_vessel_id 船舶ID
 * @param {String} enterprise_manning_vessel_role_position_id 役職ポジションID
 * @returns
 */
const newVesselEvent = (
  startDate,
  endDate,
  enterprise_manning_vessel_id,
  enterprise_manning_vessel_role_position_id
) => {
  return new CrewEventModel({
    startDate: startDate,
    endDate: endDate,
    phantom_group_key: EventHelperCommon.genPhantomGroupKey(),
    enterprise_manning_vessel_id: enterprise_manning_vessel_id,
    enterprise_manning_vessel_role_position_id: enterprise_manning_vessel_role_position_id,
    event_type: C.SCHEDULING_EVENT_TYPE.VESSEL,
    scheduling_status: C.SCHEDULING_STATUS.PLANNING,
  });
};

// 同種類のイベントか判定
const isSameEventType = (event1, event2) => {
  if (event1.event_type !== event2.event_type) {
    return false;
  }

  switch (event1.event_type) {
    case C.SCHEDULING_EVENT_TYPE.ASHORE:
      return isSameAshoreEvent(event1, event2);
    case C.SCHEDULING_EVENT_TYPE.VESSEL:
      return isSameVesselEvent(event1, event2);
    default:
      return false;
  }
};

/**
 *
 * @param {*} event1
 * @param {*} event2
 * @returns
 */
const isSameVesselEvent = (event1, event2) => {
  return (
    event1.resourceId === event2.resourceId &&
    event1.enterprise_manning_vessel_id ===
      event2.enterprise_manning_vessel_id &&
    event1.enterprise_manning_vessel_crew_id ===
      event2.enterprise_manning_vessel_crew_id
  );
};

/**
 * 同じ種類の下船中様態イベントかを判定するヘルパー関数
 * @param {*} event1
 * @param {*} event2
 * @returns
 */
const isSameAshoreEvent = (event1, event2) => {
  return (
    event1.resourceId === event2.resourceId &&
    event1.enterprise_manning_status_id ===
      event2.enterprise_manning_status_id &&
    event1.enterprise_manning_vessel_role_position_id ===
      event1.enterprise_manning_vessel_role_position_id
  );
};

export default {
  newAshoreEvent,
  newDayOffRequestEvent,
  newVesselEvent,
  isSameEventType,
  isSameVesselEvent,
  isSameAshoreEvent,
};
